import React, { useState, useRef, useEffect, useMemo } from 'react';
import { filter } from './AutocompleteInput';

const ALLOWED_CHARS = /[0-9]/;

const generateFlagCode = (countryCode) => `flag:${countryCode.toLowerCase()}-4x3`;

const PhoneInput = (props) => {
  const { list, error, onChange, placeholder, label, style, value, name = 'mobile' } = props;

  const OutsideClickRef = useRef(null);
  const selectedFlagRef = useRef(null);
  const selectedFlag = document.getElementById(`flag-${name}`);

  const [dirty, setDirty] = useState(false);

  const [showList, setShowList] = useState(false);
  const [country, setCountry] = useState({
    dialCode: '+249',
    code: 'sd'
  });

  const [mobileNumber, setMobileNumber] = useState('');

  const [data, setData] = useState({ query: null, mode: '' });

  const handleSelect = (country) => {
    setDirty(true);

    if (country) {
      setCountry(country);
      setShowList(false);
    }

    if (country && mobileNumber) {
      onChange(`${country.dialCode}${mobileNumber}`);
    }

  };

  const handleMobileChange = ({ target }) => {
    setDirty(true);
    setMobileNumber(target.value);
    onChange(`${country.dialCode}${target.value}`);

    if (target.value === '') {
      onChange(null);
    }

  };
  const handleOutsideClick = (e) => {
    if (OutsideClickRef.current && !OutsideClickRef.current.contains(e.target)) {
      setShowList(false);
    }
  };

  const filteredList = useMemo(() => filter(data.query, list), [data.query, list]);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (value && !dirty) {
      const dialCode = `+${value.split('').splice(0, 3).join('')}`;
      const mobile = value.split('').splice(3).join('');
      const country = list.find(country => country.dialCode === dialCode);

      if (country) {
        setCountry(country);
      }
      setMobileNumber(mobile || '');

      setDirty(true);
    }
  }, [value, list, country, mobileNumber, setMobileNumber, dirty, setDirty, selectedFlag]);

  useEffect(() => {
    //try ref change method in future
    if (country.dialCode && selectedFlag) selectedFlag.dataset.icon = generateFlagCode(country.code);
  }, [country, selectedFlag]);

  return (
    <div className="phone-input" ref={OutsideClickRef} >
      {label && <label>رقم الهاتف</label>}
      <div className={error ? 'input-box error' : 'input-box'}>

        <input
          type="number"
          placeholder={placeholder}
          value={mobileNumber}
          min="0"
          onChange={handleMobileChange}
          onKeyPress={(event) => {
            if (!ALLOWED_CHARS.test(event.key)) {
              event.preventDefault();
            }
          }}
        />

        <div className='phone-input-flag-container' onClick={() => setShowList(!showList)}>
          <p>{country.dialCode || '+249'}</p>
          <span id={`flag-${name}`} className="iconify" ref={selectedFlagRef}></span>
        </div>
      </div>

      {error && <span className="error-message">{error}</span>}
      {
        showList &&
        <div className='phone-input-list-container' style={style}>
          <div className='phone-input-search-head'><input type='text' placeholder='ابحث عن الدولة'
            onChange={({ target: { value } }) => setData({ ...data, query: value })}
            onKeyDown={({ key }) => { if (key === 'Enter') handleSelect(filteredList[0]); }} /></div>
          <div>
            {
              filteredList.sort((a, b) => a.nameEn > b.nameEn ? 1 : -1).map(country => {

                const listFlagIcon = `flag:${country.code.toLowerCase()}-4x3`;
                const ListFlag = document.getElementById('listFlag');
                if (ListFlag) ListFlag.dataset.icon = listFlagIcon;

                return (
                  <div className='phone-input-list-item' onClick={() => handleSelect(country)}>
                    <p>{country.nameEn}</p>
                    <div>
                      <p>{country.dialCode}</p>
                      <span id="listFlag" className="iconify" data-icon={listFlagIcon}></span>              
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      }
    </div>
  );
};

export default PhoneInput;